import React, { useState, useEffect, useContext } from 'react';
import { slide as Menu } from "react-burger-menu";
import logo from "../../images/logo_algodesign.png";
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { AppContext } from '@/AppContext';
import { IsSupervisorMode } from '@users';

const useStyles = makeStyles(theme => ({
    divWorksite: {
        backgroundColor: 'var(--color11)',
        color: '#ffffff',
        width: '100%',
        justifySelf: 'anchor-center',
        fontSize: '13px'
    }
}));

function WorksiteDescription(props) {
    const classes = useStyles();
    const { descWorksite } = useContext(AppContext);

    useEffect(() => {
    }, [])

    return (
        IsSupervisorMode() && descWorksite != null && <div className={classes.divWorksite}>{`${i18next.t('accessType:mode.supervisor')} - ${descWorksite}`}</div>
    )
}

export default withNamespaces(['menu', 'accessType'], { wait: true })(WorksiteDescription);